import CustomImageComponent from '../custom/custom-image';

const FantasyMarcaIcon = ({ width, height, style }) => {
    return (
        <CustomImageComponent
            src={`${process.env.NEXT_PUBLIC_IMAGES}/logos/fantasy-marca.png?width=${width * 1.5}`}
            width={width ?? 30}
            height={height ?? width ?? 30}
            alt={'fantasy-marca'}
            style={style}
        />
    );
};

export default FantasyMarcaIcon;
